import React from "react";
import Tippy from '@tippyjs/react';
import { TextInput } from "@opendate-app/setlist";

import FanFilterSelect from "./FanFilterSelect";
import TimeframeFields from "./TimeframeFields";
import useQueuedFilterParams from "./useQueuedFilterParams";

import { formInputContainerStyle } from "./FanFilterGroupForm";

const AMOUNT_WIDTH = 120;

const DonationHistoryForm = (props) => {
  const {
    fanFilter,
    updateFanFilter,
  } = props;

  const options = fanFilter.filter_param_options;
  const { params, update, commitText } = useQueuedFilterParams(fanFilter, updateFanFilter);

  const renderSelect = (key, values, placeholder) => (
    <div style={formInputContainerStyle}>
      <FanFilterSelect
        aria-label={placeholder}
        placeholder={placeholder}
        options={(values || []).map((value) => ({ value, label: value }))}
        value={params[key] || null}
        onChange={(value) => update({ [key]: value })}
      />
    </div>
  );

  const renderTextInput = (key, placeholder) => (
    <div style={{ ...formInputContainerStyle, width: AMOUNT_WIDTH }}>
      <TextInput
        key={`${fanFilter.id}-${key}`}
        aria-label={placeholder}
        type="number"
        min="0"
        step="any"
        placeholder={placeholder}
        defaultValue={params[key] ?? ""}
        onBlur={(e) => commitText(key, e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") commitText(key, e.target.value);
        }}
      />
    </div>
  );

  const campaignOptions = (options.giving_campaigns || []).map((campaign) => ({
    value: campaign.id,
    label: campaign.name,
  }));

  return (
    <>
      {renderSelect("condition", options.condition, "Select a condition")}
      {renderSelect("measure", options.measure, "Select a measure")}
      {renderTextInput("min_amount", "Min $")}
      {renderTextInput("max_amount", "Max $")}
      <TimeframeFields
        params={params}
        options={options}
        resetKey={fanFilter.id}
        placeholder="Select a timeframe"
        onSelect={(key, value) => update({ [key]: value })}
        onCommitText={commitText}
        onDate={(key, value) => update({ [key]: value })}
      />

      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Giving campaign"
          placeholder="Any campaign"
          clearable
          searchable
          options={campaignOptions}
          value={params.giving_campaign_id || null}
          onChange={(value) => update({ giving_campaign_id: value || null })}
        />
      </div>

      {fanFilter.filter_validation_errors.length ? (
        <Tippy content={fanFilter.filter_validation_errors.join(" ")}>
          <i className="far fa-circle-exclamation" style={{color: "var(--sl-text-error, #FF595E)" }}/>
        </Tippy>
      ) : null}
    </>
  );
};

export default DonationHistoryForm;
